// Shipping Store

const state = {
  shippingServices: [],
  pending: false,
  activeShippingService: null,
  deliveryDate: null,
  deliveryDateConfig: null,
}

const getters = {
  isPending: ({ pending }) => pending,
}

const actions = {
  getDeliveryDateConfig({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.getItem('delivery_date_config', { shipping: payload }).then(({ data }) => {
        commit('SET_DELIVERY_DATE_CONFIG', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  getShippingServices({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.getItems('shipping').then(({ data }) => {
        commit('SET_SHIPPING_SERVICES', data.services)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  updateDeliveryDate({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      if (payload) {
        const checkDate = typeof payload === 'object' ? payload : new Date(payload)
        if (checkDate instanceof Date && isFinite(checkDate)) {
          const parsedDate = checkDate.toLocaleDateString(
            'de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' })
          let parts = parsedDate.split('.')
          if (parts.length >= 3) {
            payload = parts.length >= 3 ? `${parts[2]}-${parts[1]}-${parts[0]}` : payload
          } else {
            parts = parsedDate.split('-')
            if (parts.length >= 3) {
              payload = parts.length >= 3 ? `${parts[0]}-${parts[1]}-${parts[2]}` : payload
            }
          }
        }
      }
      this.api.items.createItem('carts.mine.delivery_date', { delivery_date: payload }).then(_ => {
        commit('SET_DELIVERY_DATE', payload)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  updateShippingService({ commit, dispatch }, payload) {
    const currentService = state.activeShippingService
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.createItem('carts.mine.shipping', { shipping: payload }).then(_ => {
        commit('SET_ACTIVE_SERVICE', payload)
        commit('SET_PENDING')
        dispatch('updateDeliveryDate', !currentService || currentService === payload ? state.deliveryDate : null)
        dispatch('getDeliveryDateConfig', payload)
        resolve()
      })
    })
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  SET_DELIVERY_DATE: (state, payload) => {
    state.deliveryDate = payload
  },
  SET_DELIVERY_DATE_CONFIG: (state, payload) => {
    state.deliveryDateConfig = payload
  },
  SET_SHIPPING_SERVICES: (state, payload) => {
    state.shippingServices = payload
  },
  SET_ACTIVE_SERVICE: (state, payload) => {
    state.activeShippingService = payload
  },
  INIT_ACTIVE_SERVICE: (state, payload) => {
    state.activeShippingService = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
